"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNLengthHex = exports.prettifyHex = void 0;
const prettifyHex = (hexStr) => {
    let res = '';
    for (let i = 0; i < hexStr.length; i += 2) {
        res += `${hexStr.substring(i, i + 2)} `;
    }
    return res.trim().toUpperCase();
};
exports.prettifyHex = prettifyHex;
const getNLengthHex = (l, n = 0) => {
    if (l % 2 !== 0) {
        throw new Error('Invalid length for hex representation, must be even');
    }
    const s = n.toString(16).toUpperCase();
    const a = new Array(l).fill('0');
    a.splice(a.length - s.length, s.length, ...s);
    return a.join('');
};
exports.getNLengthHex = getNLengthHex;
